import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const HISTORY_KEY = "app_history_stack";

export const useSafeBackNavigation = (fallbackPath: string = "/") => {
  const navigate = useNavigate();
  const location = useLocation();

  // Initialize stack from sessionStorage
  const getHistoryStack = (): string[] => {
    const stored = sessionStorage.getItem(HISTORY_KEY);
    return stored ? JSON.parse(stored) : [];
  };

  const setHistoryStack = (stack: string[]) => {
    sessionStorage.setItem(HISTORY_KEY, JSON.stringify(stack));
  };

  // Track every internal route change
  useEffect(() => {
    const stack = getHistoryStack();
    const currentPath = location.pathname;

    // Avoid duplicates if user refreshes same page
    if (stack[stack.length - 1] !== currentPath) {
      stack.push(currentPath);
      setHistoryStack(stack);
    }
  }, [location.pathname]);

const goBack = () => {
  const stack = getHistoryStack();

  // Remove current page
  stack.pop();

  let lastPath: string | undefined;

  while (stack.length > 0) {
    const candidate = stack.pop();
    if (candidate && candidate.startsWith("/")) {
      // Remove query params and hash
      const cleanPath = candidate.split("?")[0].split("#")[0];
      lastPath = cleanPath;
      break;
    }
  }

  setHistoryStack(stack);

  navigate(lastPath ?? fallbackPath, { replace: true });
};

  return { goBack, navigate };
};